import amplitude from '@/components/util/analytics/amplitude';
import { track } from '@/components/util/analytics/amplitude.util';
import { AMPLITUDE_EVENT_SOURCES } from '@/components/broadcast/constants/emailBroadcast.constants';

const AMPLITUDE_EVENT_TYPE_EMAIL = 'Email';
const EMAIL_BROADCAST_SOURCE = 'Email Broadcasts';


/*
    Email Broadcasts
*/

export const trackBardBroadcastCreated = (eventSource, isSpaApp) => {
    track(
        amplitude.keap.events.START_EMAIL_BROADCAST,
        {
            'Event Source': eventSource,
            Type: AMPLITUDE_EVENT_TYPE_EMAIL,
        },
        isSpaApp,
    );
};

export const trackUnlayerBroadcastCreated = (eventSource, isSpaApp) => {
    track(
        amplitude.keap.events.BROADCAST_CREATED,
        {
            'Event Source': eventSource,
            Type: AMPLITUDE_EVENT_TYPE_EMAIL,
        },
        isSpaApp,
    );
};

export const trackSendBroadcastSuccess = (eventSource, sendType, isSpaApp) => {
    track(
        amplitude.keap.events.BROADCAST_SENT,
        {
            'Event Source': eventSource,
            Status: 'Success',
            'Send Type': sendType,
        },
        isSpaApp,
    );
};

export const trackSendBroadcastError = (eventSource, sendType, isSpaApp) => {
    track(
        amplitude.keap.events.BROADCAST_SENT,
        {
            'Event Source': eventSource,
            Status: 'Error',
            'Sending Flow': 'Unified sending flow',
        },
        isSpaApp,
    );
};


/*
    Campaign Emails
*/

export const trackToggleReadyClicksDone = (isSpaApp) => {
    track(
        amplitude.keap.events.CAMPAIGN_BROADCAST_UNLAYER_SAVED_ITEM,
        {
            Keap: 'false',
            ItemSaved: 'flow',
        },
        isSpaApp,
    );
};


/*
    Shared between Campaigns and Email Broadcasts
*/

export const trackChooseStartFromScratchTemplate = (eventSource, isSpaApp) => {
    track(
        amplitude.keap.events.BROADCAST_CREATE_A_TEMPLATE,
        {
            'Event Source': eventSource,
        },
        isSpaApp,
    );
};

export const trackChooseTextOnlyTemplate = (eventSource, isSpaApp) => {
    track(
        amplitude.keap.events.BROADCAST_TEXT_ONLY,
        {
            'Event Source': eventSource,
        },
        isSpaApp,
    );
};

export const trackChooseExistingTemplate = (eventSource, isSpaApp) => {
    track(
        amplitude.keap.events.BROADCAST_SELECT_TEMPLATE,
        {
            'Event Source': eventSource,
        },
        isSpaApp,
    );
};

export const trackSetUpEmailDomain = (eventSource, isSpaApp) => {
    track(
        amplitude.keap.events.SET_UP_EMAIL_DOMAIN,
        {
            'Event Source': eventSource,
            ...getEmailDomainPayload(eventSource),
        },
        isSpaApp,
    );
};

export const trackAddEmailDomain = (eventSource, isSpaApp) => {
    track(
        amplitude.keap.events.ADD_EMAIL_DOMAIN,
        {
            'Event Source': eventSource,
            ...getEmailDomainPayload(eventSource),
        },
        isSpaApp,
    );
};

export const trackAuthenticateEmailDomain = (eventSource, isSpaApp) => {
    track(
        amplitude.keap.events.AUTHENTICATE_EMAIL_DOMAIN,
        {
            'Event Source': eventSource,
            ...getEmailDomainPayload(eventSource),
        },
        isSpaApp,
    );
};

const getEmailDomainPayload = (eventSource) => {
    return (eventSource === AMPLITUDE_EVENT_SOURCES.UNLAYER_BROADCAST_BUILDER)
        ? {
            Source: EMAIL_BROADCAST_SOURCE,
            Type: AMPLITUDE_EVENT_TYPE_EMAIL,
        }
        : {};
};
